module.exports = __webpack_public_path__ + "html/settings_c9c127e77be01124d624a1776c596de6.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/settings.html
// module id = UTMY
// module chunks = 51